export default "__VITE_ASSET__Cb1mavZM__ 640w, __VITE_ASSET__BnBsSbkp__ 1024w";